module.exports = __webpack_public_path__ + "img/circles.b94d622c.png";